/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ResponseSurveyQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        departmentId: {
    type: 'number',
},
        question: {
    type: 'string',
    isRequired: true,
},
        allowComment: {
    type: 'boolean',
    isRequired: true,
},
        allowFeedback: {
    type: 'boolean',
    isRequired: true,
},
        title: {
    type: 'string',
},
        subTitle: {
    type: 'string',
},
        order: {
    type: 'number',
},
        createdAt: {
    type: 'string',
},
    },
};